export const BOOKING_STATE_TOKEN = 'BOOKING';

export const BOOKING_API_PATHS = {
    bookings: 'client/bookings',
    past_bookings: 'client/past_bookings',
    unitStatus: 'unit_status'
};